
<div class="auth-section">
  <div class="auth-bg-outer-section">
    <div class></div>
    <div class></div>
  </div>
  <div class="auth-content-section">
    <div class="auth-image-content">
      <div class="">
        <h2>Streamline Your Logistics Operations</h2>
        <p>Our advanced Transportation Management System helps carriers optimize routes, reduce costs, and improve customer satisfaction.</p>
        <ul>
          @for (item of rightSIdeTexts; track item.id ?? item) {
            <li>
              <span>
                <app-svg-icons [icons]="item?.icon"/>
              </span>
              <div class="">
                <h3>{{item?.title}}</h3>
                <p>{{item?.subTitle}}</p>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="auth-container">
      <span class="trolly"><img src="../../../../assets/images/trolly.jpg" /></span>
      <span class="truck"><img src="../../../../assets/images/truck.jpg" /></span>
      <span class="container"><img src="../../../../assets/images/container.jpg" /></span>
      <div class="auth-form-section">
        <ng-content #name></ng-content>


      </div>

    </div>
  </div>
  <div class="versions-section">
    <p class="app-version">App Version<b>{{fVersion}}</b></p>
    <p>BE<b>{{bVersion()}}</b></p>
  </div>

</div>
